/* eslint-disable no-param-reassign */

import produce from 'immer';

import {ApplicationCredentialsModel} from '../../../models/api/applicationCredentialsModel';
import {ServerAuthenticationConfig} from '../../../models/api/serverModel';
import {ServerEditorAction, ServerEditorActionTypesEnum} from './serverEditorActions';
import {DEFAULT_APPLICATION_CREDENTIALS, ServerEditorState} from './serverEditorState';

export function serverEditorReducer(state: ServerEditorState, action: ServerEditorAction): ServerEditorState {
  switch (action.type) {
    case ServerEditorActionTypesEnum.UPDATE_ORIGIN:
      return updateServerOriginReducer(state, action.origin);

    case ServerEditorActionTypesEnum.UPDATE_AUTHENTICATION_CONFIG:
      return updateServerAuthenticationConfigReducer(state, action.authenticationConfig);

    case ServerEditorActionTypesEnum.UPDATE_APPLICATION_CREDENTIALS:
      return updateServerApplicationCredentialsReducer(state, action.applicationCredentials);

    default:
      return state;
  }
}

/*
 * Helpers.
 */

function updateServerOriginReducer(state: ServerEditorState, origin: string) {
  return produce(state, (draft) => {
    draft.serverState.origin = origin;
  });
}

function updateServerAuthenticationConfigReducer(
  state: ServerEditorState,
  authenticationConfig: ServerAuthenticationConfig,
) {
  return produce(state, (draft) => {
    draft.serverState.authenticationConfig = authenticationConfig;

    // Reset credentials if they are no longer valid.
    if (draft.applicationCredentialsState.credentials.type !== authenticationConfig.strategy) {
      draft.applicationCredentialsState.credentials =
        DEFAULT_APPLICATION_CREDENTIALS[authenticationConfig.strategy];
    }
  });
}

function updateServerApplicationCredentialsReducer(
  state: ServerEditorState,
  applicationCredentials: ApplicationCredentialsModel,
) {
  return produce(state, (draft) => {
    draft.applicationCredentialsState.credentials = applicationCredentials;
  });
}
